export default __webpack_public_path__ + "static/media/match.2f893197.svg";